<template>
  <div class="UserForm">
    <form class="form" method="post" :action="formAction"  @submit.prevent="submit" v-if="!sentData">
      <h4 class="subTitle">
        SCRIVI QUALCOSA DI TE
      </h4>
      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.first_name.label}}</label>
          </div>
          <div class="field">
            <input 
              type="text" 
              name="first_name" 
              class="textInput" 
              :placeholder="project.first_name.placeholder" 
              v-model="$v.first_name.$model" />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.first_name">{{ errors.first_name }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.last_name.label}}</label>
          </div>
          <div class="field">
            <input 
              type="text" 
              name="last_name" 
              class="textInput" 
              :placeholder="project.last_name.placeholder"
              v-model="$v.last_name.$model" />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.last_name">{{ errors.last_name }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>
      
      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="label">
            <label>{{project.company.label}}</label>
          </div>
          <div class="field">
            <input 
              type="text" 
              name="company" 
              class="textInput" 
              v-model="company"
              :placeholder="project.company.placeholder" />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.company">{{ errors.company }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>
      
      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.email.label}}</label>
          </div>
          <div class="field">
            <input 
              type="text" 
              name="email" 
              class="textInput" 
              :placeholder="project.email.placeholder"
              v-model="$v.email.$model" />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.email">{{ errors.email }}</span>
            </div>
            <div class="info">
            </div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.phone.label}}</label>
          </div>
          <div class="field">
            <input 
              type="text" 
              name="phone" 
              class="textInput" 
              :placeholder="project.phone.placeholder"
              v-model="$v.phone.$model" />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.phone">{{ errors.phone }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="label">
            <label>{{project.user_info.label}}</label>
          </div>
          <div class="field">
            <textarea 
              name="user_info" 
              class="textInput" 
              :placeholder="project.user_info.placeholder"
              v-model="$v.user_info.$model"></textarea>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.user_info">{{ errors.user_info }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.youtube_profile_url.label}}</label>
          </div>
          <div class="field">
            <input 
              type="text" 
              name="youtube_profile_url" 
              class="textInput" 
              :placeholder="project.youtube_profile_url.placeholder"
              v-model="$v.youtube_profile_url.$model" />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.youtube_profile_url">{{ errors.youtube_profile_url }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.social_profile_url.label}}</label>
          </div>
          <div class="field">
            <input
              type="text" 
              name="social_profile_url" 
              class="textInput" 
              v-model="social_profile_url"
              :placeholder="project.social_profile_url.placeholder" />
          </div>
          <div class="msg">
            <div class="error">
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>
      
      <h4 class="subTitle">
        PARLACI DEL TUO PROGETTO
      </h4>
      
      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.title.label}}</label>
          </div>
          <div class="field">
            <input
              type="text" 
              name="title" 
              class="textInput" 
              :placeholder="project.title.placeholder"
              v-model="$v.title.$model" />
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="$v.title.$error">Campo obbligatorio</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.category.label}}</label>
          </div>
          <div class="field">
            <div class="customSelectWrapper">
                <select class="customSelect" name="category" v-model="$v.category.$model">
                  <option 
                    v-for="o in project.category.options" 
                    :value="o.value">
                      {{o.text}}
                  </option>
                </select>
            </div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.category">{{ errors.category }}</span>
            </div>
            <div class="info">
            </div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="label">
            <label>{{project.description.label}}</label>
          </div>
          <div class="field">
            <textarea 
              name="description" 
              class="textInput" 
              :placeholder="project.description.placeholder"
              v-model="$v.description.$model"></textarea>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.description">{{ errors.description }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.presentation_url.label}}</label>
          </div>
          <div class="field">
            <input 
              type="text" 
              name="presentation_url" 
              class="textInput" 
              v-model="presentation_url"
              :placeholder="project.presentation_url.placeholder" />
          </div>
          <div class="msg">
            <div class="error">
            </div>
            <div class="info"></div>
          </div>
        </div>
        <div class="fieldWrapper flex50">
          <div class="label">
            <label>{{project.budget_required.label}}</label>
          </div>
          
          <div class="field">
            <div class="flexWrapper">
              <input 
                type="text" 
                name="budget_required" 
                class="textInput" 
                :placeholder="project.budget_required.placeholder"
                v-model="$v.budget_required.$model" />
              <div class="input-group-addon">&euro;</div>
            </div>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="errors.budget_required">{{ errors.budget_required }}</span>
            </div>
            <div class="info">
              Ricorda: se il tuo progetto sarà selezionato, riceverai un finanziamento da BPER Banca solo se raccoglierai, in crowdfunding, almeno il 25% del budget.
            </div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="label">
            <label>Regolamento*</label>
          </div>
          <div class="overflowWrapper">
            <div class="overflowContent" v-html="rules">
            </div>
          </div>
          <div class="msg"></div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="customCheckboxWrapper">
            <input id="id_policy" type="checkbox" name="policy" v-model="policy" />
            <label for="id_policy" class="label" v-html="project.policy.label">
            </label>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="$v.policy.$invalid">{{ errors.policy }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="customCheckboxWrapper">
            <input id="id_accept_rule_yes" type="radio" name="accept_rule" :value="true" v-model="$v.accept_rule.$model" />
            <label for="id_accept_rule_yes" class="label"  v-html="project.accept_rule_yes.label" >
            </label>
          </div>
          <div class="msg">
            <div class="info"></div>
          </div>
        </div>
      </div>

      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <div class="customCheckboxWrapper">
            <input id="id_accept_rule_no" type="radio" name="accept_rule" :value="false" v-model="$v.accept_rule.$model" />
            <label for="id_accept_rule_no" class="label"  v-html="project.accept_rule_no.label" >
            </label>
          </div>
          <div class="msg">
            <div class="error">
              <span v-if="$v.accept_rule.$invalid">{{ errors.accept_rule }}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
      </div>


      <div class="flexRow">
        <div class="fieldWrapper flex100">
          <input type="submit" value="Invia la tua idea">
          <div class="msg">
            <div class="error">
              <span v-if="!!globalErrorMsg">{{globalErrorMsg}}</span>
            </div>
            <div class="info"></div>
          </div>
        </div>
        
      </div>

    </form>
  </div>
</template>

<script>

  import axios from 'axios';

  import GenericBigText from './generic_big_text'

  import { required, email, integer, numeric, sameAs } from 'vuelidate/lib/validators'
  import { checkIfSet } from '../mixins/check_if_set'

  import { validationMixin } from 'vuelidate';

  export default {
    name: 'UserForm',
    components:{
      GenericBigText
    },
    mixins: [validationMixin],
    data(){
      let obj = {
      },
      localProject = {};
      Object.keys(this.project).forEach((k)=>{
        let o = {},
            p = {};
        o[k] = this.project[k].value;
        obj = {...obj, ...o};

        p[k] = this.project[k];

        localProject = {...localProject, ...p};
      });

      return {
        sentData: false,
        localProject: localProject,
        globalErrorMsg: '',
        test: false,
        ...obj,
      };
    },
    props: {
      defaultErrorMsg: {
        type: String, default: "Attenzione! Correggi gli errori nel form."
      },
      defaultErrorRequest: {
        type: String, default: "Errore di comunicazione con il server."
      },
      formAction: {
        type: String, default: ""
      },
      rules: {
        type: String, default: ""
      },
      project: {
        type: Object,
        default: ()=>{}
      }
    },
    computed: {
      fields: function(){ 
        return Object.keys(this.project);
      },

      errors(){
        let obj = {},
            fields = Object.keys(this.localProject);
        fields.forEach((f)=>{
          let v = !!this.localProject[f].remoteError ? this.localProject[f].remoteError : !!this.$v[f] && !!this.$v[f].$error ? this.buildErrorMsg(f) : "";
          let o = {
            [f]: v
          };
          obj = {...obj, ...o}
        })
        return obj
      },

      formData(){
        let obj = {};
        for(let k in this.$v){
          if(!!this.$v[k] && (!!this.$v[k].$model || this.$v[k].$model !== null)){
            var o = {};
            o[k] = this.$v[k].$model;
            obj = {...obj, ...o };
          }
        }
        obj['budget_required'] = obj['budget_required'].replace(/,/g, '.');
        obj['company'] = this.company;
        obj['presentation_url'] = this.presentation_url;
        obj['social_profile_url'] = this.social_profile_url;
        return obj;
      }
    },
    methods: {
      focusFirstStatus(component = this) {
        for(let i=0; i < this.fields.length; i++){
          let f = this.fields[i];
          let el = this.$el.querySelector(`[name=${f}]`);
          if(!!this.$v[f] && this.$v[f].$dirty && this.$v[f].$error){
            el.focus();
            return
          }
        }
      },

      onPolicyChange(e){
        this.localProject.policy.value = e.target.checked;
        this.$v.policy.$touch();
      },

      buildErrorMsg(f){
        let me = this,
            errors = [],
            field = this.$v[f];

        for(let k in field.$params){
          let v = field.$params[k].type;
          if(field[v] === false){
            errors.push(me.getErrorMessage(f, field.$params[k]))
          }
        }
        return errors.join('<br />');
      },

      getErrorMessage(field, param){
        let f = param.type;
        if(!!this.localProject[field].localError){
          return this.localProject[field].localError
        }else{
          switch(f){
            case 'required':
            return "Campo obbligatorio"


            case 'email':
            return "E-mail non valida"

            case 'integer':
            return "Valore non valido"

            case 'numeric':
            return "Valore non valido"

            case 'sameAs':
            return "Campo obbligatorio"

            default:
            return "Valore non valido"
          }
        }
      },

      submit() {
        var me = this;
        me.$v.$touch();
        me.$nextTick(() => me.focusFirstStatus());
        if(!me.$v.$invalid){
          me.$el.querySelector('[type=submit]').setAttribute('disabled', true);
          for(let k in me.localProject){
            me.$set(me.localProject[k], 'remoteError', "")
          }
          if (!window.PDB) {
            // Not in PDB, add Authorization header
            axios.defaults.headers.common['Authorization'] = 'Token 427ac565f2cbda2371026e17af9394e9281a11fb';
          }

          axios.post(me.formAction, me.formData)
          .then(function (response) {
            me.sentData = true;
            me.$emit('success')
          })
          .catch(function (error) {
            if(!!error.response && !!error.response.data){
              if(!!error.response.data.detail){
                me.globalErrorMsg = error.response.data.detail;
              }else{
                let errors = JSON.parse(error.response.data.error);
                for(let k in errors){
                  try{
                    let v = errors[k]; 
                    me.$set(me.localProject[k], 'remoteError', v.join('<br>'))    
                  }catch(e){
                    console.log(e);
                  }
                }
                me.globalErrorMsg = me.defaultErrorMsg
              }
            }else{
              me.globalErrorMsg = me.defaultErrorRequest
            }
            
          })
          .finally(function(){
            if(!!me.$el.querySelector('[type=submit]')){
              me.$el.querySelector('[type=submit]').removeAttribute('disabled');
            }
          });
        }
      }
    },
    validations(){
      var obj = {};
      Object.keys(this.project).forEach((k)=>{
        let o = {},
            v = this.project[k].validate;

        if(!!v.required){
          o[k] = { ...o[k], required }
          obj = {...obj, ...o};
        }
        if(!!v.email){
          o[k] = { ...o[k], email }
          obj = {...obj, ...o};
        }
        if(!!v.integer){
          o[k] = { ...o[k], integer }
          obj = {...obj, ...o};
        }

        if(!!v.numeric){
          o[k] = { ...o[k], numeric }
          obj = {...obj, ...o};
        }

        if(!!v.checkIfSet){
          o[k] = { ...o[k], checkIfSet }
          obj = {...obj, ...o};
        }

        if(!!v.sameAs){
          //o[k] = { sameAs: sameAs(() => v.sameAs.sameAs) }
          //obj = {...obj, ...o};
        }
      });

      obj['policy'] = { sameAs: sameAs(()=>true)}
      obj['accept_rule'] = { sameAs: sameAs(()=>true)}

      return obj;
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';

</style>
